module.exports = __webpack_public_path__ + "img/1F1F8-1F1FD.5405e317.svg";